var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 15.85L8.51172 13.9V28.309C8.51185 28.4656 8.54281 28.6205 8.60284 28.7651C8.66286 28.9097 8.75077 29.041 8.86155 29.1516C8.97233 29.2622 9.10381 29.3499 9.24848 29.4097C9.39315 29.4695 9.54818 29.5002 9.70472 29.5H28.8047C28.9614 29.5004 29.1167 29.4699 29.2616 29.4103C29.4065 29.3506 29.5382 29.2629 29.6492 29.1523C29.7602 29.0417 29.8483 28.9103 29.9084 28.7656C29.9686 28.6209 29.9996 28.4657 29.9997 28.309V23L19.5807 15.85Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 3.5H9.70472C9.54818 3.49987 9.39315 3.53057 9.24848 3.59035C9.10381 3.65014 8.97233 3.73783 8.86155 3.84842C8.75077 3.95902 8.66286 4.09035 8.60284 4.23492C8.54281 4.37949 8.51185 4.53446 8.51172 4.691V10L19.5807 16.5L25.4417 18.45L29.9997 16.5V10L19.5807 3.5Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51172 10H19.5807V16.5H8.51172V10Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4337 8.70001H8.51172V24.95H16.4337C16.7494 24.9484 17.0517 24.8226 17.2752 24.5996C17.4987 24.3767 17.6254 24.0747 17.6277 23.759V9.89101C17.6254 9.57535 17.4987 9.27333 17.2752 9.0504C17.0517 8.82747 16.7494 8.70158 16.4337 8.70001Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7827 9.34998H8.51172V25.6H15.7827C16.0984 25.5984 16.4007 25.4725 16.6242 25.2496C16.8477 25.0267 16.9744 24.7246 16.9767 24.409V10.541C16.9744 10.2253 16.8477 9.9233 16.6242 9.70037C16.4007 9.47743 16.0984 9.35155 15.7827 9.34998Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7827 9.34998H8.51172V24.3H15.7827C16.0984 24.2984 16.4007 24.1725 16.6242 23.9496C16.8477 23.7267 16.9744 23.4246 16.9767 23.109V10.541C16.9744 10.2253 16.8477 9.9233 16.6242 9.70037C16.4007 9.47743 16.0984 9.35155 15.7827 9.34998Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.1317 9.34998H8.51172V24.3H15.1317C15.4474 24.2984 15.7497 24.1725 15.9732 23.9496C16.1967 23.7267 16.3234 23.4246 16.3257 23.109V10.541C16.3234 10.2253 16.1967 9.9233 15.9732 9.70037C15.7497 9.47743 15.4474 9.35155 15.1317 9.34998Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.194 9.34998H15.132C15.4482 9.34971 15.7516 9.47501 15.9755 9.69834C16.1994 9.92166 16.3255 10.2247 16.326 10.541V22.459C16.3255 22.7752 16.1994 23.0783 15.9755 23.3016C15.7516 23.5249 15.4482 23.6502 15.132 23.65H3.194C3.03738 23.6502 2.88224 23.6196 2.73746 23.5599C2.59267 23.5002 2.46108 23.4125 2.35019 23.3019C2.2393 23.1913 2.1513 23.0599 2.09121 22.9153C2.03113 22.7707 2.00013 22.6156 2 22.459V10.541C2.00013 10.3844 2.03113 10.2293 2.09121 10.0847C2.1513 9.94003 2.2393 9.80865 2.35019 9.69804C2.46108 9.58744 2.59267 9.49977 2.73746 9.44004C2.88224 9.38032 3.03738 9.34971 3.194 9.34998Z",
    fill: "url(#paint0_linear_711_19106)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7002 20.373L8.2112 16.489L5.9112 12.627H7.7582L9.0132 15.1C9.1292 15.334 9.2132 15.508 9.2512 15.624H9.2682C9.3502 15.436 9.4372 15.255 9.5282 15.078L10.8702 12.631H12.5702L10.2112 16.471L12.6302 20.376H10.8212L9.3712 17.665C9.30387 17.5485 9.24666 17.4263 9.2002 17.3H9.1762C9.13391 17.4231 9.07754 17.5409 9.0082 17.651L7.5152 20.373H5.7002Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8061 3.5H19.5811V10H30.0001V4.691C29.9999 4.53438 29.9689 4.37932 29.9088 4.23469C29.8488 4.09005 29.7608 3.95868 29.6499 3.84807C29.539 3.73746 29.4074 3.64979 29.2626 3.59007C29.1178 3.53034 28.9627 3.49974 28.8061 3.5Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5811 16.5H30.0001V23H19.5811V16.5Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_711_19106",
    x1: 4.494,
    y1: 8.41398,
    x2: 13.832,
    y2: 24.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.d3441089835d80b706acbe871932b8cd.svg";
export { ForwardRef as ReactComponent };